module.exports = __webpack_public_path__ + "img/hero-background-wave.d844fbe7.jpeg";